const FOOTER_LINKS = {
  '综艺类型': ['搞笑综艺', '真人秀综艺', '音乐竞演', '旅行体验', '推理探案', '治愈慢综'],
  '热门综艺': ['奔跑吧兄弟', '明星大侦探', '向往的生活', '乘风破浪的姐姐', '密室大逃脱', '这！就是街舞'],
  '平台服务': ['高清播放', '每日更新', '免费全集', '全终端适配', '智能推荐'],
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-white">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-2xl font-heading font-black text-white tracking-tight no-underline whitespace-nowrap">
              6789影视
            </a>
            <p className="text-sm text-background-300 mt-4 leading-relaxed max-w-xs">
              6789影视 — 综艺在线观看平台，提供最新综艺、热门综艺、搞笑综艺和真人秀综艺免费全集，高清流畅不缓冲，每日同步更新精彩内容。
            </p>
          </div>

          {Object.entries(FOOTER_LINKS).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-sm font-semibold text-white mb-4 whitespace-nowrap">{category}</h3>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href="#hero"
                      onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }}
                      className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-background-400">
              <span className="whitespace-nowrap">&copy; 2026 6789影视</span>
              <span className="hidden sm:block text-background-600">|</span>
              <span className="whitespace-nowrap">综艺在线观看 · 最新综艺 · 热门综艺</span>
              <span className="hidden sm:block text-background-600">|</span>
              <span className="whitespace-nowrap">搞笑综艺 · 真人秀综艺 · 免费全集</span>
            </div>
            <div className="flex items-center gap-4">
              <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="w-9 h-9 rounded-full bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-arrow-up-line"></i>
              </a>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-background-700/30">
            <h4 className="text-xs font-semibold text-background-300 mb-3 text-center">合作伙伴</h4>
            <p className="text-xs text-background-500 text-center">更多合作伙伴即将入驻，敬请期待</p>
          </div>
        </div>
      </div>
    </footer>
  );
}